// @flow

import React from 'react';
import moment from 'moment';
import urlHelper from 'helpers/url.helper';

const delayHoursBeforeSecondReminder = 48

const Company = (
  { translate, selectedApp, _setSelectedApp, appCompany }:
    { translate: any, selectedApp: Array<Number>, _setSelectedApp: Function, appCompany: Object }) => {

  function _toggleCompany(company) {
    const { last_sent } = appCompany.reminder_ws;
    if (_hoursSinceLastCreated(last_sent) < delayHoursBeforeSecondReminder) { return };

    const index = selectedApp.indexOf(company.id);
    if (index === -1) {
      selectedApp.push(company.id);
    } else {
      selectedApp.splice(index, 1);
    }

    _setSelectedApp(selectedApp);
  };

  function _hoursSinceLastCreated(lastSent) {
    return lastSent ? moment().diff(moment(lastSent), 'hours') : Infinity;
  }

  function _renderIcon(appCompany, checked) {
    const { last_sent, enabled } = appCompany.reminder_ws;
    if (!enabled) return null;

    const sinceLastCreated = _hoursSinceLastCreated(last_sent);

    if ((sinceLastCreated > delayHoursBeforeSecondReminder)) {
      return (
        <div className="reminder--ico-box" onClick={() => { _toggleCompany(appCompany); }}>
          <div className={'reminder--ico-checked ' + checked} />
        </div>
      );
    } else {
      return (
        <div className="reminder--ico-box" />
      );
    }
  };

  function _renderSentInfo(appCompany) {
    if (!appCompany.reminder_ws.last_sent) { return null; };

    const hoursAfterLastSent = _hoursSinceLastCreated(appCompany.reminder_ws.last_sent);
    if (!appCompany.reminder_ws.last_sent || hoursAfterLastSent > delayHoursBeforeSecondReminder) { return null; };

    const sentOn = moment(appCompany.reminder_ws.last_sent).format('DD.MM.YYYY');
    const sendNext = moment(appCompany.reminder_ws.last_sent).add(2, 'days').format('DD.MM.YYYY');
    const byCustomer = appCompany.reminder_ws.by_editor ? <span className="reminder--orange by-support">{translate('reminder.by_customer')}</span> : null;

    return (
      <div className="reminder--sent-note hidden-xs hidden-sm">
        <div className="desktop-view">
          <div className="reminder--company-info-box">
            <div className="reminder--info-item auto-margin">
              <div className="text-holder">
                <span className="reminder--orange">
                  {translate('reminder.sent_on', { date: sentOn })}
                </span>
                {byCustomer}
                <span className="">{translate('reminder.send_next', { date: sendNext })}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  function _renderSentInfoMobile(appCompany) {
    if (!appCompany.reminder_ws.last_sent) { return null; };

    const hoursAfterLastSent = _hoursSinceLastCreated(appCompany.reminder_ws.last_sent);
    if (!appCompany.reminder_ws.last_sent || hoursAfterLastSent > delayHoursBeforeSecondReminder) { return null; };

    const sendNext = moment(appCompany.reminder_ws.last_sent).add(2, 'days').format('DD.MM.YYYY');
    return (
      <div className="mobile-reminder-send visible-xs visible-sm">
        <span className="">{translate('reminder.send_next', { date: sendNext })}</span>
      </div>
    );
  };

  function _renderNumberInfo(phone) {
    if (!phone) { return null; };

    return (
      <div className="reminder--info-item">
        <div className="icon-holder">
          <a className="tel" href={`tel:${phone}`}>
            <i className="fa fa-phone"></i>
          </a>
        </div>
        <div className="text-holder hidden-xs hidden-sm">
          <span className="company-number">{phone}</span>
        </div>
      </div>
    );
  };

  function _renderMailInfo(mail) {
    if (!mail) { return null; };

    return (
      <div className="reminder--info-item">
        <div className="icon-holder">
          <a href={`mailto:${mail}`}>
            <i className="fa fa-envelope"></i>
          </a>
        </div>
        <div className="text-holder hidden-xs hidden-sm">
          <span>{mail}</span>
        </div>
      </div>
    );
  };

  function _renderCompany() {
    let phone;
    let mail;
    if (appCompany.starfish_company) {
      phone = appCompany.starfish_company.phone ? appCompany.starfish_company.phone : null;
      mail = appCompany.starfish_company.email ? appCompany.starfish_company.email : null;
    } else {
      phone = appCompany.company.meta_phone ? appCompany.company.meta_phone : null;
      mail = appCompany.company.meta_email ? appCompany.company.meta_email : null;
    }

    const checked = selectedApp.indexOf(appCompany.id) !== -1 ? '' : ' reminder--ico-checked-grey';

    return (
      <div className="reminder--company-box" key={appCompany.id}>
        <div className="inform">
          {_renderIcon(appCompany, checked)}
          <div className="reminder--company-image">
            <img
              src={urlHelper.imageUrl(appCompany.company.meta_logo_large)}
              alt={appCompany.company.meta_name}
              className='img-responsive'
              onClick={() => { _toggleCompany(appCompany); }}
            />
          </div>
          <div className="reminder--company-info-box">
            {_renderNumberInfo(phone)}
            {_renderMailInfo(mail)}
          </div>
          {_renderSentInfo(appCompany)}
        </div>
        {_renderSentInfoMobile(appCompany)}
      </div>
    );
  };

  return (
    <div>
      {_renderCompany()}
    </div>
  );
};

export default Company;



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/reminder/company.js